import {Alert, FormControl} from 'platform/components';
import {Show} from 'platform/foundation';

import {FieldValues, useFormState} from 'react-hook-form';

import {suffixTestId, TestIdProps} from 'shared/web';

type FormRootErrorAlertProps<TFieldValues extends FieldValues> = {
  control: FormControl<TFieldValues>;
} & TestIdProps;

/**
 * Shows an API error that belongs to no single input, set on the form as `root.server`. The form
 * clears it on the next submit.
 */
export function FormRootErrorAlert<TFieldValues extends FieldValues>(
  props: FormRootErrorAlertProps<TFieldValues>
) {
  const {errors} = useFormState({control: props.control});

  return (
    <Show when={errors.root?.server?.message}>
      {(message) => (
        <Alert
          variant="error"
          message={message}
          data-testid={suffixTestId('formRootError', props)}
        />
      )}
    </Show>
  );
}
